module.exports = __webpack_public_path__ + "1cb3ca97a3e76ffea607d52947d43273.MP3";